import React, {useEffect} from 'react';
import { useCart } from '../../store/CartContext';
import { useNavigate } from 'react-router-dom';
import './CartBtn.css';
import CartIcon from "../icons/cart-icon";

export default function CartBtn() {
    const { items, fetchCart } = useCart();
    const navigate = useNavigate();
    useEffect(() => {
        if (items?.length === 0) {
            (async () => await fetchCart())();
        }
    }, [items]);

    const handleClick = () => {
        navigate('/courses-cart');
    };

    return (
        <div className="cart__btn-icon">
            {items.length > 0 && <button className='cart__btn-body' onClick={handleClick}>
                <CartIcon />
            <span className="cart__item-count">{items.length}</span>
            </button>}
        </div>
    );
}
